import React from "react";
import { dateFormatter } from "../../../../utils/dateFormatter";
import classes from "./orderAddressPage.module.css";
import { StatusBadge } from "../../../../component/bulk/bulkSpares/bulkSparesDetail/BulkSpareDetailForm";

export const OrderAddressPage = ({ address }) => {
  return (
    <div className={classes.box}>
      {/* TOP SUMMARY */}
      <div className={`${classes.card} ${classes.cardHighlight}`}>
        <div className={classes.box__section}>
          <div className={classes.box__section__top}>
            <InfoRow label="Order Id" value={`#${address?.order_id}`} />
            <StatusBadge status={address?.order_status} />
          </div>
          <InfoRow label="Date" value={dateFormatter(address?.ordered_on)} />
          <InfoRow label="Items" value={address?.num_of_items} />
          <InfoRow label="Amount" value={`₹${address?.total_amount}`} />
        </div>
      </div>

      {/* CUSTOMER */}
      <div className={classes.card}>
        <h3 className={classes.sectionTitle}>Customer Information</h3>
        <InfoRow label="Name" value={address?.name} />
        <InfoRow label="Phone" value={address?.mobile_no} />
      </div>

      {/* DELIVERY */}
      <div className={classes.card}>
        <h3 className={classes.sectionTitle}>Delivery Information</h3>
        <InfoRow label="Address" value={address?.address} />
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className={classes.row}>
    <span className={classes.row__label}>{label}</span>
    <span className={classes.row__value}>{value || "-"}</span>
  </div>
);
